(function () {
  'use strict';

  const initReviewCards = (section) => {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const scroller = section.querySelector('[data-review-cards-scroller]');
    const dotsContainer = section.querySelector('[data-review-cards-dots]');
    if (!scroller || !dotsContainer) return;

    const items = Array.from(scroller.querySelectorAll('.review-cards__card-item'));
    const count = items.length;
    if (count < 2) return;

    // Build one dot per card
    const dots = Array.from({ length: count }, (_, i) => {
      const dot = document.createElement('button');
      dot.className = 'review-cards__dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Go to review ${i + 1}`);
      dot.addEventListener('click', () => {
        const gap = parseFloat(getComputedStyle(scroller).gap) || 20;
        scroller.scrollTo({ left: i * (items[0].offsetWidth + gap), behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
      return dot;
    });

    // Update active dot on scroll
    let rafId;
    scroller.addEventListener('scroll', () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const gap = parseFloat(getComputedStyle(scroller).gap) || 20;
        const step = (items[0]?.offsetWidth || 0) + gap;
        const activeIndex = step > 0
          ? Math.min(Math.round(scroller.scrollLeft / step), count - 1)
          : 0;
        dots.forEach((dot, i) => dot.classList.toggle('active', i === activeIndex));
      });
    }, { passive: true });
  };

  const initAll = () => {
    document.querySelectorAll('[data-review-cards]:not([data-initialized="true"])').forEach(initReviewCards);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', ({ target }) => {
    const section = target.querySelector('[data-review-cards]') ?? target;
    initReviewCards(section);
  });

  document.addEventListener('shopify:section:unload', ({ target }) => {
    const section = target.querySelector('[data-review-cards]') ?? target;
    if (section) delete section.dataset.initialized;
  });
})();
